 <div id="containerLeftMenu" style="margin-right: 15px">  
    <section id="column1" >
        <np-menu [location]="NavigationLocation.Side"></np-menu>
    </section>
    <import-export *ngIf="showImportExport"/>
 </div> 